import client from './client';

export const listBoundaries = (params) =>
  client.get('/boundaries', { params }).then((r) => r.data);

export const createBoundary = (data) =>
  client.post('/boundaries', data).then((r) => r.data);

export const updateBoundary = (id, data, params) =>
  client.patch(`/boundaries/${id}`, data, { params }).then((r) => r.data);

export const deleteBoundary = (id, params) =>
  client.delete(`/boundaries/${id}`, { params }).then((r) => r.data);

export const setPrimary = (id, params) =>
  client.post(`/boundaries/${id}/set-primary`, null, { params }).then((r) => r.data);

export const getUploadUrl = (data) =>
  client.post('/boundaries/upload-url', data).then((r) => r.data);

export const importFromS3 = (data) =>
  client.post('/boundaries/import-s3', data).then((r) => r.data);

export const importFromFile = (tenantId, formData, config) =>
  client.post(`/boundaries/import?tenant_id=${tenantId}`, formData, config).then((r) => r.data);
